// Step-up del vault (VLT-355): cuando el Worker responde step_up_required
// (cuenta con MFA pero sesión sin el desafío superado), la capa de servicios
// pide aquí la verificación y la UI global la resuelve con un diálogo TOTP.
// Registro simple: un solo handler (el diálogo montado en el layout).

let handler: (() => Promise<boolean>) | null = null;

export function registerStepUpHandler(h: (() => Promise<boolean>) | null): void {
  handler = h;
}

/** Pide al usuario superar el desafío MFA. true = sesión elevada a aal2. */
export function requestStepUp(): Promise<boolean> {
  return handler ? handler() : Promise.resolve(false);
}
